<template>
  <div class="d-flex flex-column" id="app">
    <topo logoURL="/imgs/brasao-pbh.png" :sigla="sigla" homeLink="/">Logo PBH</topo>

    <div class="container conteudo">
      <b-row class="justify-content-md-center">
        <b-col>
          <msgs msgRef="msgs"></msgs>
          <router-view></router-view>
        </b-col>
      </b-row>
    </div>

        <vue-progress-bar></vue-progress-bar>
		
    <rodape logoURL="/imgs/brasao-pbh.png" :versao="versao"></rodape>
  </div>
</template>

<script>
import { insereGoogleRecaptcha } from '../helpers/index.js'

export default {
  methods: {
  },
  computed: {
    sigla() {
      return this.$env.VUE_APP_SIGLA;
    },
    versao() {
      return this.$env.VUE_APP_VERSAO;
    },
    /**
     * Retorna os itens do menu
     */
    itens_menu() {
      let itens = [
        {
          titulo: "Menu",
          subitens: [
            { titulo: "Lista pedidos", to: { name: "lista-pedidos" } },
            { titulo: "Lista exames", to: { name: "lista-exames" } },
            { titulo: "Sair", to: { name: "home" } }
          ]
        }
      ];
      return itens;
    },
  },
  mounted() {
    this.$Progress.finish()
  },
  created() {
    this.$Progress.start()
    insereGoogleRecaptcha(this.$env.VUE_APP_GOOGLE_RECAPTCHA_KEY);

    this.$router.beforeEach((to, from, next) => {
      this.$Progress.start()
      next();
    });

    this.$router.afterEach(() => {
      this.$Progress.finish()
    });
  }
};
</script>

